import { customSessionClient } from 'better-auth/client/plugins';
import { twoFactorClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

export const authClient = createAuthClient({
	basePath: '/api/auth',
	plugins: [
		customSessionClient(),
		twoFactorClient({
			onTwoFactorRedirect: () => {
				window.location.href = '/verify-2fa';
			},
		}),
	],
});

export const { useSession, signIn, signUp, signOut } = authClient;
